module.exports = __webpack_public_path__ + "/img/ChipArray2SideConvex-Custom-Footprint-u0oTIP.svg";